<template>
  <div class="kpis-container">
    <!-- Scroll Container Sincronizado -->
    <div ref="synchronizedScrollContainer" class="synchronized-scroll-container">
      <!-- Filtros Globais -->
      <div class="filter-section mb-6 sm:mb-8 bg-white/95 dark:bg-gray-800/95 backdrop-blur-lg border border-white/40 dark:border-gray-700/50 rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300">

      
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <!-- Filtro de Agenda -->
        <div class="space-y-2">
          <label class="block text-sm font-semibold mb-3" :style="{ color: 'var(--clinic-font-color)' }">
            <div class="flex items-center gap-2">
              <svg class="w-4 h-4" :style="{ color: 'var(--clinic-icon-color)' }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
              Agenda
            </div>
          </label>
          <select 
            v-model="globalFilters.agenda" 
            @change="applyGlobalFilters"
            class="w-full border-2 border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 rounded-xl px-4 py-3.5 text-sm text-gray-800 dark:text-gray-100 shadow-md hover:shadow-lg transition-all duration-300 focus:outline-none focus:border-2 hover:border-gray-300 dark:hover:border-gray-500"
            :style="{ 'focus:border-color': 'var(--clinic-btn-bg)', 'focus:ring-color': 'var(--clinic-btn-bg)' }"
          >
            <option value="">Todas as agendas</option>
            <option v-for="agenda in agendas" :key="agenda?.id || agenda" :value="agenda?.id || agenda">
              {{ agenda?.name || agenda }}
            </option>
          </select>
        </div>

        <!-- Filtro de Data Início -->
        <div class="space-y-2">
          <label class="block text-sm font-semibold mb-3" :style="{ color: 'var(--clinic-font-color)' }">
            <div class="flex items-center gap-2">
              <svg class="w-4 h-4" :style="{ color: 'var(--clinic-icon-color)' }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              Data Início
            </div>
          </label>
          <input 
            type="date" 
            v-model="globalFilters.dateStart"
            @change="applyGlobalFilters"
            class="w-full border-2 border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 rounded-xl px-4 py-3.5 text-sm text-gray-800 dark:text-gray-100 shadow-md hover:shadow-lg transition-all duration-300 focus:outline-none focus:border-2 hover:border-gray-300 dark:hover:border-gray-500"
            :style="{ 'focus:border-color': 'var(--clinic-btn-bg)', 'focus:ring-color': 'var(--clinic-btn-bg)' }"
          />
        </div>

        <!-- Filtro de Data Fim -->
        <div class="space-y-2">
          <label class="block text-sm font-semibold mb-3" :style="{ color: 'var(--clinic-font-color)' }">
            <div class="flex items-center gap-2">
              <svg class="w-4 h-4" :style="{ color: 'var(--clinic-icon-color)' }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              Data Fim
            </div>
          </label>
          <input 
            type="date" 
            v-model="globalFilters.dateEnd"
            @change="applyGlobalFilters"
            class="w-full border-2 border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 rounded-xl px-4 py-3.5 text-sm text-gray-800 dark:text-gray-100 shadow-md hover:shadow-lg transition-all duration-300 focus:outline-none focus:border-2 hover:border-gray-300 dark:hover:border-gray-500"
            :style="{ 'focus:border-color': 'var(--clinic-btn-bg)', 'focus:ring-color': 'var(--clinic-btn-bg)' }"
          />
        </div>

        <!-- Botão de Limpar Filtros -->
        <div class="flex items-end">
          <button 
            @click="clearGlobalFilters"
            class="w-full font-semibold py-3.5 px-4 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg flex items-center justify-center gap-2 border-2 clinic-clear-btn hover:-translate-y-0.5"
            style="background: var(--clinic-btn-bg); color: white; border-color: var(--clinic-btn-bg);"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
            </svg>
            Limpar Filtros
          </button>
        </div>
      </div>
      </div>

      <!-- Content Section -->
      <div class="content-section">
        <!-- Layout Desktop/Tablet - Grid -->
        <div v-if="!isMobile" class="w-full">
      <grid-layout
        v-model:layout="layout"
        :col-num="colNum"
        :row-height="rowHeight"
        :is-draggable="isDraggable"
        :is-resizable="isResizable"
        :vertical-compact="true"
        :use-css-transforms="true"
        :margin="[12, 12]"
        :responsive="true"
        :breakpoints="{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }"
        :cols="{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }"
        class="w-full"
      >
        <grid-item
          v-for="item in layout"
          :key="item.i"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          @resized="resizedEvent"
          class="rounded-xl sm:rounded-2xl overflow-hidden transition-all duration-300 ease-out cursor-move hover:-translate-y-2 hover:scale-[1.02] hover:shadow-2xl group"
        >
          <div class="bg-white/90 dark:bg-gray-800/90 backdrop-blur-md border border-white/30 dark:border-gray-700/40 rounded-xl sm:rounded-2xl h-full flex flex-col transition-all duration-300 relative shadow-lg hover:shadow-2xl hover:bg-white/95 dark:hover:bg-gray-800/95">
            <!-- Ícone de arrastar -->
            <div class="absolute top-3 right-3 opacity-0 group-hover:opacity-70 transition-opacity duration-200 z-10">
              <GripVertical class="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 dark:text-gray-500" />
            </div>
            
            <div class="p-4 sm:p-5 md:p-6 border-b border-slate-200/60 dark:border-gray-700/40 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 md:gap-5">
              <div 
                class="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-xl sm:rounded-2xl flex items-center justify-center text-white flex-shrink-0 shadow-lg"
                :style="{ backgroundColor: item.color, boxShadow: `0 8px 25px ${item.color}40` }"
              >
                <component 
                  :is="getIconComponent(item.chartType)" 
                  class="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7" 
                />
              </div>
              <div class="flex-1 min-w-0">
                <h3 class="text-base sm:text-lg md:text-xl font-bold text-gray-900 dark:text-gray-100 leading-tight mb-1 truncate">
                  {{ item.title }}
                </h3>
                <span class="text-xs sm:text-sm md:text-base text-gray-600 dark:text-gray-400 font-medium block truncate">
                  {{ item.subtitle }}
                </span>
              </div>
              <!-- Botões de tipo de gráfico -->
              <div class="flex gap-1.5 sm:gap-2" v-if="item.chartTypes">
                <button
                  v-for="(type, typeKey) in item.chartTypes"
                  :key="typeKey"
                  @click="changeChartType(item.i, typeKey)"
                  :class="[
                    'w-7 h-7 sm:w-8 sm:h-8 md:w-9 md:h-9 rounded-lg sm:rounded-xl flex items-center justify-center transition-all duration-300 text-xs shadow-sm hover:shadow-md',
                    item.currentChartType === typeKey 
                      ? 'bg-gradient-to-br from-blue-500 to-blue-600 text-white shadow-lg scale-110 ring-2 ring-blue-200 dark:ring-blue-800' 
                      : 'bg-white/80 dark:bg-gray-700/80 text-gray-600 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-700 hover:scale-105 border border-gray-200/50 dark:border-gray-600/50'
                  ]"
                  :title="type.title"
                >
                  <component :is="type.icon" class="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                </button>
              </div>
            </div>
            <div class="p-4 sm:p-5 md:p-6 flex-grow flex items-center justify-center min-h-0 overflow-hidden bg-gradient-to-br from-gray-50/30 to-white/50 dark:from-gray-800/30 dark:to-gray-900/50">
              <!-- Estado de Loading -->
              <div v-if="loadingStates[item.i]" class="flex flex-col items-center justify-center gap-3">
                <RefreshCw class="w-8 h-8 sm:w-10 sm:h-10 text-blue-500 animate-spin" />
                <p class="text-sm text-gray-600 dark:text-gray-400 font-medium">Carregando dados...</p>
              </div>
              
              <!-- Estado de Erro -->
              <div v-else-if="errorStates[item.i]" class="flex flex-col items-center justify-center gap-3 text-center px-4">
                <div class="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
                  <svg class="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                  </svg>
                </div>
                <div>
                  <p class="text-sm font-semibold text-red-600 dark:text-red-400 mb-1">Erro ao carregar dados</p>
                  <p class="text-xs text-gray-500 dark:text-gray-400">{{ errorStates[item.i] }}</p>
                </div>
              </div>
              
              <!-- Gráfico -->
              <KpiChart
                v-else
                :type="item.currentChartType || item.chartType"
                :labels="item.chartData.labels"
                :data="item.chartData.data"
                :colors="item.chartData.colors"
                :key="`${item.i}-${item.currentChartType || item.chartType}`"
              />
            </div>
          </div>
        </grid-item>
      </grid-layout>
    </div>

    <!-- Layout Mobile - Lista -->
    <div v-else class="mobile-list-container">
      <div
          v-for="item in layout"
          :key="item.i"
          class="mobile-card"
        >
        <!-- Header do Card Mobile -->
        <div class="p-4 border-b border-slate-200/60 dark:border-gray-700/40">
          <div class="flex items-center gap-3 mb-3">
            <div 
              class="w-10 h-10 rounded-xl flex items-center justify-center text-white flex-shrink-0 shadow-lg"
              :style="{ backgroundColor: item.color, boxShadow: `0 4px 15px ${item.color}40` }"
            >
              <component 
                :is="getIconComponent(item.chartType)" 
                class="w-5 h-5" 
              />
            </div>
            <div class="flex-1 min-w-0">
              <h3 class="text-lg font-bold text-gray-900 dark:text-gray-100 leading-tight mb-1">
                {{ item.title }}
              </h3>
              <span class="text-sm text-gray-600 dark:text-gray-400 font-medium">
                {{ item.subtitle }}
              </span>
            </div>
          </div>
          
          <!-- Botões de tipo de gráfico para mobile -->
          <div class="flex gap-2 justify-center" v-if="item.chartTypes">
            <button
              v-for="(type, typeKey) in item.chartTypes"
              :key="typeKey"
              @click="changeChartType(item.i, typeKey)"
              :class="[
                'px-3 py-2 rounded-lg flex items-center gap-2 transition-all duration-300 text-sm font-medium',
                item.currentChartType === typeKey 
                  ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg' 
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              ]"
              :title="type.title"
            >
              <component :is="type.icon" class="w-4 h-4" />
              <span class="hidden xs:inline">{{ type.title }}</span>
            </button>
          </div>
        </div>
        
        <!-- Conteúdo do Gráfico Mobile -->
        <div class="p-4 bg-gradient-to-br from-gray-50/30 to-white/50 dark:from-gray-800/30 dark:to-gray-900/50">
          <div class="h-64 flex items-center justify-center">
            <!-- Estado de Loading Mobile -->
             <div v-if="loadingStates[item.i]" class="flex flex-col items-center justify-center gap-3">
               <RefreshCw class="w-10 h-10 text-blue-500 animate-spin" />
               <p class="text-sm text-gray-600 dark:text-gray-400 font-medium">Carregando dados...</p>
             </div>
            
            <!-- Estado de Erro Mobile -->
            <div v-else-if="errorStates[item.i]" class="flex flex-col items-center justify-center gap-3 text-center px-4">
              <div class="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
                <svg class="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                </svg>
              </div>
              <div>
                <p class="text-sm font-semibold text-red-600 dark:text-red-400 mb-1">Erro ao carregar dados</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ errorStates[item.i] }}</p>
              </div>
            </div>
            
            <!-- Gráfico Mobile -->
            <KpiChart
              v-else
              :type="item.currentChartType || item.chartType"
              :labels="item.chartData.labels"
              :data="item.chartData.data"
              :colors="item.chartData.colors"
            />
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, computed, onUnmounted } from 'vue';
import { GridLayout, GridItem } from 'grid-layout-plus';
import { 
  BarChart3, TrendingUp, PieChart, Donut, Activity, GripVertical, 
  BarChart2, LineChart, AreaChart, RefreshCw 
} from 'lucide-vue-next';
import KpiChart from './KpiChart.vue';

// Referência para o container de scroll sincronizado
const synchronizedScrollContainer = ref(null);

// Otimização de scroll para dispositivos móveis
const optimizeScrollForMobile = () => {
  if (typeof window !== 'undefined' && synchronizedScrollContainer.value) {
    const container = synchronizedScrollContainer.value;
    
    // Adicionar suporte a touch events para scroll mais responsivo
    let scrollTimeout;
    
    const handleScrollStart = () => {
      container.style.scrollBehavior = 'auto'; // Desabilitar scroll-behavior durante touch
    };
    
    const handleScrollEnd = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        container.style.scrollBehavior = 'smooth'; // Reabilitar scroll suave
      }, 150);
    };
    
    container.addEventListener('touchstart', handleScrollStart, { passive: true });
    container.addEventListener('touchend', handleScrollEnd, { passive: true });
    container.addEventListener('scroll', handleScrollEnd, { passive: true });
    
    // Cleanup function
    return () => {
      container.removeEventListener('touchstart', handleScrollStart);
      container.removeEventListener('touchend', handleScrollEnd);
      container.removeEventListener('scroll', handleScrollEnd);
    };
  }
};

// Propriedades responsivas do grid
const colNum = computed(() => {
  if (typeof window !== 'undefined') {
    const width = window.innerWidth;
    if (width >= 1200) return 12;
    if (width >= 996) return 10;
    if (width >= 768) return 6;
    if (width >= 480) return 4;
    return 2;
  }
  return 12;
});

const rowHeight = computed(() => {
  if (typeof window !== 'undefined') {
    const width = window.innerWidth;
    if (width >= 768) return 30;
    if (width >= 480) return 25;
    return 20;
  }
  return 30;
});

const isDraggable = computed(() => {
  if (typeof window !== 'undefined') {
    return window.innerWidth >= 768; // Desabilitar arrastar em telas pequenas
  }
  return true;
});

const isResizable = computed(() => {
  if (typeof window !== 'undefined') {
    return window.innerWidth >= 768; // Desabilitar redimensionar em telas pequenas
  }
  return true;
});

// Detecção de dispositivo móvel
const isMobile = computed(() => {
  if (typeof window !== 'undefined') {
    return window.innerWidth < 768; // Considera mobile abaixo de 768px
  }
  return false;
});

// Estado dos gráficos
const chartTypes = ref({
  tempo_atendimento: 'bar',
  agendamentos_status: 'pie',
  laudos_medico: 'bar'
});

// Estados de loading e erro para cada KPI
const loadingStates = ref({
  tempo_atendimento: false,
  agendamentos_status: false,
  laudos_medico: false
});

const errorStates = ref({
  tempo_atendimento: null,
  agendamentos_status: null,
  laudos_medico: null
});

// Agendas da API
const agendas = ref([])

// Filtros globais
const globalFilters = ref({
  agenda: '',
  dateStart: '',
  dateEnd: ''
})

// Função para carregar agendas da API
const loadAgendas = async () => {
  try {
    const response = await fetch('/api/v1/schedules/list/?page_size=50', {
      credentials: 'include'
    });
    
    if (response.ok) {
      const data = await response.json();
      // Verificar se data é um array e filtrar itens nulos
      if (Array.isArray(data)) {
        agendas.value = data.filter(agenda => agenda && agenda.id && agenda.name);
      } else if (data && data.results && Array.isArray(data.results)) {
        // Se a API retorna um objeto com results (paginação)
        agendas.value = data.results.filter(agenda => agenda && agenda.id && agenda.name);
      } else {
        agendas.value = [];
      }
      console.log('Agendas carregadas:', agendas.value);
    } else {
      console.error('Erro ao carregar agendas:', response.status, response.statusText);
      // Fallback para agendas simuladas se a API falhar
      agendas.value = [
        { id: 1, name: 'Cardiologia' },
        { id: 2, name: 'Neurologia' },
        { id: 3, name: 'Ortopedia' },
        { id: 4, name: 'Pediatria' }
      ];
    }
  } catch (error) {
    console.error('Erro ao carregar agendas:', error);
    // Fallback para agendas simuladas se houver erro
    agendas.value = [
      { id: 1, name: 'Cardiologia' },
      { id: 2, name: 'Neurologia' },
      { id: 3, name: 'Ortopedia' },
      { id: 4, name: 'Pediatria' }
    ];
  }
};

const layout = ref([
  { 
    x: 0, y: 0, w: 6, h: 8, i: 'tempo_atendimento', 
    title: 'Tempo de Atendimento', 
    subtitle: 'Por agenda',
    color: '#3b82f6',
    chartType: 'bar',
    currentChartType: 'bar',
    chartTypes: {
      bar: { title: 'Gráfico de Barras', icon: BarChart2 },
      line: { title: 'Gráfico de Linha', icon: LineChart },
      pie: { title: 'Gráfico de Pizza', icon: PieChart },
      area: { title: 'Gráfico de Área', icon: AreaChart }
    },
    chartData: { 
      labels: [], 
      data: [],
      colors: []
    },
    filters: {
      agenda: { value: '' },
      dateRange: { start: '', end: '' }
    },
    apiEndpoint: '/api/v1/reports/kpi/tempo-atendimento/'
  },
  { 
    x: 6, y: 0, w: 6, h: 8, i: 'agendamentos_status', 
    title: 'Agendamentos', 
    subtitle: 'Por status',
    color: '#10b981',
    chartType: 'pie',
    currentChartType: 'pie',
    chartTypes: {
      pie: { title: 'Gráfico de Pizza', icon: PieChart },
      doughnut: { title: 'Gráfico de Rosca', icon: Donut },
      bar: { title: 'Gráfico de Barras', icon: BarChart2 }
    },
    chartData: { 
      labels: [], 
      data: [],
      colors: []
    },
    filters: {
      agenda: { value: '' },
      dateRange: { start: '', end: '' }
    },
    apiEndpoint: '/api/v1/reports/kpi/agendamentos-status/'
  },
  { 
    x: 0, y: 8, w: 12, h: 8, i: 'laudos_medico', 
    title: 'Laudos por Médico', 
    subtitle: 'Total de laudos',
    color: '#8b5cf6',
    chartType: 'bar',
    currentChartType: 'bar',
    chartTypes: {
      bar: { title: 'Gráfico de Barras', icon: BarChart2 },
      line: { title: 'Gráfico de Linha', icon: LineChart },
      area: { title: 'Gráfico de Área', icon: AreaChart }
    },
    chartData: { 
      labels: [], 
      data: [],
      colors: []
    },
    filters: {
      agenda: { value: '' },
      dateRange: { start: '', end: '' }
    },
    apiEndpoint: '/api/v1/reports/kpi/laudos-medico/'
  }
]);

// Função para mapear tipos de gráfico para ícones LucideVue
const getIconComponent = (chartType) => {
  const iconMap = {
    'bar': BarChart3,
    'line': TrendingUp,
    'pie': PieChart,
    'doughnut': Donut,
    'area': Activity
  };
  return iconMap[chartType] || BarChart3;
};

// Função para mudar tipo de gráfico
const changeChartType = async (itemId, newType) => {
  try {
    const item = layout.value.find(i => i.i === itemId);
    if (item) {
      item.currentChartType = newType;
      chartTypes.value[itemId] = newType;
      
      // Aguardar um tick para garantir que a mudança foi aplicada
      await nextTick();
      
      // Recarregar dados com novo tipo de gráfico
      await loadKpiData(itemId);
    }
  } catch (error) {
    console.error(`Erro ao mudar tipo de gráfico ${itemId} para ${newType}:`, error);
  }
};

// Função para carregar dados dos KPIs
const loadKpiData = async (itemId) => {
  try {
    const item = layout.value.find(i => i.i === itemId);
    if (!item || !item.apiEndpoint) return;

    // Iniciar loading
    loadingStates.value[itemId] = true;
    errorStates.value[itemId] = null;

    const params = new URLSearchParams();
    
    // Adicionar filtros específicos para cada KPI
    if (itemId === 'tempo_atendimento') {
      if (item.filters.agenda && item.filters.agenda.value) {
        params.append('agenda', item.filters.agenda.value);
      }
      if (item.filters.dateRange && item.filters.dateRange.start && item.filters.dateRange.end) {
        params.append('data_inicio', item.filters.dateRange.start);
        params.append('data_fim', item.filters.dateRange.end);
      }
    } else if (itemId === 'agendamentos_status') {
      if (item.filters.agenda && item.filters.agenda.value) {
        params.append('agenda', item.filters.agenda.value);
        console.log('Filtro de agenda aplicado no KPI:', item.filters.agenda.value);
      } else {
        console.log('Nenhum filtro de agenda aplicado no KPI');
      }
      
      if (item.filters.dateRange && item.filters.dateRange.start && item.filters.dateRange.end) {
        params.append('data_inicio', item.filters.dateRange.start);
        params.append('data_fim', item.filters.dateRange.end);
        console.log('Período KPI especificado:', item.filters.dateRange.start, 'até', item.filters.dateRange.end);
      } else {
        // Se não especificou datas, usar período padrão (6 meses atrás)
        const periodo = getPeriodoMesVigente();
        params.append('data_inicio', periodo.data_inicio);
        params.append('data_fim', periodo.data_fim);
        console.log('Usando período padrão (6 meses atrás):', periodo.data_inicio, 'até', periodo.data_fim);
      }
    } else if (itemId === 'laudos_medico') {
      if (item.filters.agenda && item.filters.agenda.value) {
        params.append('agenda', item.filters.agenda.value);
      }
      if (item.filters.dateRange && item.filters.dateRange.start && item.filters.dateRange.end) {
        params.append('data_inicio', item.filters.dateRange.start);
        params.append('data_fim', item.filters.dateRange.end);
      }
    }

    console.log(`Carregando dados para ${itemId} com parâmetros:`, params.toString());

    const response = await fetch(`${item.apiEndpoint}?${params.toString()}`, {
      credentials: 'include'
    });

    if (response.ok) {
      const data = await response.json();
      console.log(`Dados recebidos para ${itemId}:`, data);
      updateChartData(itemId, data);
    } else {
      console.error(`Erro na resposta da API para ${itemId}:`, response.status, response.statusText);
      const errorText = await response.text();
      console.error(`Erro detalhado para ${itemId}:`, errorText);
      
      // Definir mensagem de erro baseada no status
      let errorMessage = 'Erro ao carregar dados';
      if (response.status === 401) {
        errorMessage = 'Erro de autenticação - faça login novamente';
      } else if (response.status === 403) {
        errorMessage = 'Acesso negado - sem permissão';
      } else if (response.status === 404) {
        errorMessage = 'Dados não encontrados';
      } else if (response.status >= 500) {
        errorMessage = 'Erro interno do servidor';
      }
      
      errorStates.value[itemId] = errorMessage;
    }
  } catch (error) {
    console.error(`Erro ao carregar dados do KPI ${itemId}:`, error);
    
    // Definir mensagem de erro baseada no tipo de erro
    let errorMessage = 'Erro de conexão';
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      errorMessage = 'Erro de rede - verifique sua conexão';
    }
    
    errorStates.value[itemId] = errorMessage;
  } finally {
    // Finalizar loading
    loadingStates.value[itemId] = false;
  }
};

// Função para atualizar dados do gráfico
 const updateChartData = (itemId, data) => {
   const item = layout.value.find(i => i.i === itemId);
   if (!item || !data || data.length === 0) return;
 
   switch (itemId) {
    case 'tempo_atendimento': {
      // Processar dados de tempo de atendimento
      if (Array.isArray(data)) {
        const labels = data.map(item => item.periodo || item.data || item.schedule__name || 'Período');
        const values = data.map(item => item.tempo_medio || item.tempo || 0);

        item.chartData = {
          labels: labels,
          data: values,
          colors: ['#28a745', '#1e7e34', '#155724', '#0d4017', '#062911']
        };
      } else if (data.tempo_medio !== undefined) {
        // Se for um valor único
        item.chartData = {
          labels: ['Tempo Médio'],
          data: [data.tempo_medio],
          colors: ['#28a745']
        };
      }
      break;
    }
       
     case 'agendamentos_status': {
        // Mapeamento de status em inglês para português
        const statusTranslation = {
          'confirmed': 'Confirmado',
          'pending': 'Pendente',
          'cancelled': 'Cancelado',
          'completed': 'Realizado',
          'laudado': 'Laudado',
          'falta': 'Falta',
          'no_show': 'Falta',
          'rescheduled': 'Reagendado'
        };

        // Consolidar status similares
        const consolidatedData = {};
        
        data.forEach(item => {
          let status = item.status;
          
          // Traduzir status para português
          const translatedStatus = statusTranslation[status] || status;
          
          // Consolidar "Falta" e "Não Realizado" em "Falta"
          let finalStatus = translatedStatus;
          if (translatedStatus === 'Não Realizado' || status === 'no_show') {
            finalStatus = 'Falta';
          }
          
          if (consolidatedData[finalStatus]) {
            consolidatedData[finalStatus] += item.total || item.count || 0;
          } else {
            consolidatedData[finalStatus] = item.total || item.count || 0;
          }
        });

        // Converter para arrays para o gráfico
        const labels = Object.keys(consolidatedData);
        const values = Object.values(consolidatedData);
        const total = values.reduce((sum, val) => sum + val, 0);

        // Definir cores por status
        const statusColors = {
          'Confirmado': '#007bff',
          'Pendente': '#ffc107',
          'Cancelado': '#dc3545',
          'Realizado': '#28a745',
          'Laudado': '#17a2b8',
          'Falta': '#fd7e14',
          'Reagendado': '#6f42c1'
        };

        const backgroundColors = labels.map(label => statusColors[label] || '#6c757d');

        // Criar labels com porcentagens
        const labelsWithPercentage = labels.map((label, index) => {
          const percentage = total > 0 ? ((values[index] / total) * 100).toFixed(1) : '0.0';
          return `${label} (${percentage}%)`;
        });

        item.chartData = {
          labels: labelsWithPercentage,
          data: values,
          colors: backgroundColors
        };
        break;
      }
       
     case 'laudos_medico': {
        // Processar dados de laudos por médico
        const labels = data.map(item => item.finalized_by__name || item.medico || 'Não informado');
        const values = data.map(item => item.total_laudos || item.count || 0);

        item.chartData = {
          labels: labels,
          data: values,
          colors: ['#007bff', '#0056b3', '#004085', '#002752', '#001a33']
        };
        break;
      }

      default: {
        // Fallback para outros tipos de dados
        if (Array.isArray(data)) {
          const labels = data.map((item, index) => item.label || item.name || `Item ${index + 1}`);
          const values = data.map(item => item.value || item.count || 0);

          item.chartData = {
            labels: labels,
            data: values,
            colors: ['#007bff', '#0056b3', '#004085', '#002752', '#001a33']
          };
        }
        break;
      }
   }
 };

// Função para obter período padrão (6 meses atrás até hoje)
const getPeriodoMesVigente = () => {
  const now = new Date();
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(now.getMonth() - 6);
  
  return {
    data_inicio: sixMonthsAgo.toISOString().split('T')[0],
    data_fim: now.toISOString().split('T')[0]
  };
};

const resizedEvent = (i, newH, newW, newHPx, newWPx) => {
  console.log("RESIZE i=" + i + ", H=" + newH + ", W=" + newW + ", H(px)=" + newHPx + ", W(px)=" + newWPx);
};

// Carregar dados iniciais
onMounted(async () => {
  // Carregar agendas primeiro
  await loadAgendas();
  
  // Definir período padrão (6 meses atrás até hoje)
  const periodo = getPeriodoMesVigente();
  
  // Inicializar filtros globais com período padrão
  globalFilters.value.dateStart = periodo.data_inicio;
  globalFilters.value.dateEnd = periodo.data_fim;
  
  layout.value.forEach(item => {
    if (item.filters.dateRange) {
      item.filters.dateRange.start = periodo.data_inicio;
      item.filters.dateRange.end = periodo.data_fim;
    }
  });
  
  // Carregar dados de todos os KPIs
  await Promise.all([
    loadKpiData('tempo_atendimento'),
    loadKpiData('agendamentos_status'),
    loadKpiData('laudos_medico')
  ]);
  
  // Inicializar otimização de scroll para mobile
  await nextTick();
  const cleanupScrollOptimization = optimizeScrollForMobile();
  
  // Armazenar cleanup function para onUnmounted
  if (cleanupScrollOptimization) {
    onUnmounted(cleanupScrollOptimization);
  }
});

// Métodos para filtros globais
const applyGlobalFilters = async () => {
  console.log('Aplicando filtros globais:', globalFilters.value);
  
  // Aplicar filtros globais a todos os gráficos
  layout.value.forEach(item => {
    if (item.filters) {
      // Aplicar filtro de agenda
      if (item.filters.agenda) {
        item.filters.agenda.value = globalFilters.value.agenda;
      }
      
      // Aplicar filtros de data
      if (item.filters.dateRange) {
        item.filters.dateRange.start = globalFilters.value.dateStart;
        item.filters.dateRange.end = globalFilters.value.dateEnd;
      }
    }
  });
  
  // Recarregar dados de todos os gráficos
  await Promise.all([
    loadKpiData('tempo_atendimento'),
    loadKpiData('agendamentos_status'),
    loadKpiData('laudos_medico')
  ]);
};

const clearGlobalFilters = async () => {
  console.log('Limpando filtros globais');
  
  // Limpar filtros globais
  globalFilters.value = {
    agenda: '',
    dateStart: '',
    dateEnd: ''
  };
  
  // Definir período padrão (6 meses atrás até hoje)
  const periodo = getPeriodoMesVigente();
  
  // Aplicar período padrão a todos os gráficos
  layout.value.forEach(item => {
    if (item.filters) {
      if (item.filters.agenda) {
        item.filters.agenda.value = '';
      }
      if (item.filters.dateRange) {
        item.filters.dateRange.start = periodo.data_inicio;
        item.filters.dateRange.end = periodo.data_fim;
      }
    }
  });
  
  // Atualizar filtros globais com período padrão
  globalFilters.value.dateStart = periodo.data_inicio;
  globalFilters.value.dateEnd = periodo.data_fim;
  
  // Recarregar dados de todos os gráficos
  await Promise.all([
    loadKpiData('tempo_atendimento'),
    loadKpiData('agendamentos_status'),
    loadKpiData('laudos_medico')
  ]);
};
</script>

<style scoped>
/* Estilos customizados para os filtros globais */
.filter-input:focus {
  border-color: var(--clinic-btn-bg) !important;
  box-shadow: 0 0 0 3px rgba(var(--clinic-btn-bg-rgb), 0.1) !important;
}

.filter-select:focus {
  border-color: var(--clinic-btn-bg) !important;
  box-shadow: 0 0 0 3px rgba(var(--clinic-btn-bg-rgb), 0.1) !important;
}

/* Animações suaves para os filtros */
.filter-container {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.filter-container:hover {
  transform: translateY(-2px);
}

/* Estilo para o ícone do header */
.filter-icon-bg {
  background: linear-gradient(135deg, var(--clinic-btn-bg), var(--clinic-btn-bg-hover));
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Responsividade aprimorada */
@media (max-width: 640px) {
  .filter-container {
    padding: 1rem;
  }
  
  .filter-grid {
    gap: 1rem;
  }
}

/* Modo escuro aprimorado */
.dark .filter-container {
  background: rgba(31, 41, 55, 0.95);
  border-color: rgba(75, 85, 99, 0.5);
}

.dark .filter-input,
.dark .filter-select {
  background: rgba(31, 41, 55, 0.8);
  border-color: rgba(75, 85, 99, 0.6);
}

.dark .filter-input:hover,
 .dark .filter-select:hover {
   background: rgba(31, 41, 55, 0.9);
   border-color: rgba(107, 114, 128, 0.7);
 }

/* Botão Limpar com cores da clínica */
.clinic-clear-btn {
  background: var(--clinic-btn-bg) !important;
  color: white !important;
  border-color: var(--clinic-btn-bg) !important;
}

.clinic-clear-btn:hover {
  background: var(--clinic-btn-bg-hover) !important;
  border-color: var(--clinic-btn-bg-hover) !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.clinic-clear-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Estilos específicos para layout mobile em lista */
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}

.mobile-card-item {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.mobile-card-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.mobile-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.mobile-card-icon {
  width: 2.5rem;
  height: 2.5rem;
  background: linear-gradient(135deg, var(--clinic-btn-bg), var(--clinic-btn-bg-hover));
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mobile-card-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.mobile-card-content {
  min-height: 200px;
}

/* Modo escuro para cards mobile */
.dark .mobile-card-item {
  background: rgba(31, 41, 55, 0.95);
  border-color: rgba(75, 85, 99, 0.5);
}

.dark .mobile-card-title {
  color: #f9fafb;
}

.dark .mobile-card-header {
  border-bottom-color: rgba(75, 85, 99, 0.5);
}

/* Responsividade adicional */
@media (max-width: 480px) {
  .mobile-card-list {
    padding: 0.75rem;
    gap: 0.75rem;
  }
  
  .mobile-card-item {
    padding: 1rem;
  }
  
  .mobile-card-icon {
    width: 2rem;
    height: 2rem;
  }
  
  .mobile-card-title {
    font-size: 1rem;
  }
}

/* Melhorias específicas para scroll mobile */
@media (max-width: 768px) {
  /* Garantir que o body e html permitam scroll */
  html, body {
    overflow-x: hidden;
    overflow-y: visible; /* Mudança: de auto para visible */
    height: auto; /* Mudança: de 100% para auto */
  }
  
  /* Container principal sem scroll próprio */
  .min-h-full {
    min-height: auto; /* Mudança: de 100vh para auto */
    overflow: visible; /* Mudança: removendo overflow-y: auto */
    -webkit-overflow-scrolling: touch;
  }
  
  /* Lista mobile sem scroll próprio - deixar o scroll natural da página */
  .space-y-4.pb-6 {
    overflow: visible; /* Mudança: removendo overflow-y: auto */
    max-height: none; /* Mudança: removendo max-height */
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
  }
  
  /* Remover altura máxima que pode estar bloqueando */
  .max-h-screen {
    max-height: none !important;
  }
  
  /* Garantir que cards não quebrem o layout */
  .mobile-card-item {
    flex-shrink: 0;
    width: 100%;
  }
  
  /* Container principal dos KPIs sem overflow próprio */
  .kpis-container {
    overflow: visible !important;
    height: auto !important;
  }
  
  /* Container de scroll sincronizado sem scroll próprio no mobile */
  .synchronized-scroll-container {
    overflow: visible !important;
    height: auto !important;
  }
  
  /* Container de lista mobile sem scroll próprio */
  .mobile-list-container {
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
  }
}

/* Scroll personalizado para webkit */
@media (max-width: 768px) {
  /* Removendo estilos de scrollbar customizada que podem interferir */
  .space-y-4::-webkit-scrollbar {
    display: none; /* Mudança: escondendo completamente */
  }
  
  .space-y-4::-webkit-scrollbar-track {
    display: none; /* Mudança: escondendo completamente */
  }
  
  .space-y-4::-webkit-scrollbar-thumb {
    display: none; /* Mudança: escondendo completamente */
  }
  
  .space-y-4::-webkit-scrollbar-thumb:hover {
    display: none; /* Mudança: escondendo completamente */
  }
}

.space-y-4::-webkit-scrollbar {
  width: 4px;
}

.space-y-4::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
}

.space-y-4::-webkit-scrollbar-thumb {
  background: var(--clinic-btn-bg);
  border-radius: 2px;
}

.space-y-4::-webkit-scrollbar-thumb:hover {
  background: var(--clinic-btn-bg-hover);
}

/* Estilos principais do container */
.kpis-container {
  padding: 0.5rem;
  background: linear-gradient(135deg, #f8fafc 0%, #e0f2fe 50%, #e0e7ff 100%);
  min-height: auto; /* Mudança: de 100vh para auto */
  position: relative;
  overflow: visible; /* Adicionado para evitar scroll próprio */
}

@media (min-width: 640px) {
  .kpis-container {
    padding: 1rem;
  }
}

@media (min-width: 768px) {
  .kpis-container {
    padding: 1.5rem;
  }
}

@media (min-width: 1024px) {
  .kpis-container {
    padding: 2rem;
  }
}

/* Dark mode para container */
.dark .kpis-container {
  background: linear-gradient(135deg, #111827 0%, #1f2937 50%, #374151 100%);
}

/* Container principal sem scroll próprio - usar scroll natural da página */
.synchronized-scroll-container {
  height: auto; /* Mudança: de calc(100vh - 2rem) para auto */
  overflow: visible; /* Mudança: removendo overflow-y: auto */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  position: relative;
  padding: 1rem 0;
}

/* Seção de filtros - incluída na rolagem */
.filter-section {
  position: relative;
  z-index: 10;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  margin-bottom: 1.5rem !important;
}

/* Seção de conteúdo */
.content-section {
  flex: 1;
  min-height: 0;
}

/* Container da lista mobile sem scroll próprio */
.mobile-list-container {
  width: 100%;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: visible; /* Adicionado para evitar scroll próprio */
  height: auto; /* Adicionado para altura automática */
}

/* Cards mobile */
.mobile-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  overflow: visible; /* Mudança: de hidden para visible */
  transition: all 0.3s ease;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  margin: 0 1rem;
  min-height: 300px;
  height: auto; /* Adicionado para altura automática */
}

.mobile-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

/* Dark mode para cards mobile */
.dark .mobile-card {
  background: rgba(31, 41, 55, 0.95);
  border-color: rgba(75, 85, 99, 0.5);
}

/* Remover scrollbars customizadas que podem interferir no mobile */
@media (max-width: 768px) {
  .synchronized-scroll-container::-webkit-scrollbar {
    display: none; /* Esconder scrollbar customizada no mobile */
  }
  
  .synchronized-scroll-container::-webkit-scrollbar-track {
    display: none;
  }
  
  .synchronized-scroll-container::-webkit-scrollbar-thumb {
    display: none;
  }
  
  .synchronized-scroll-container::-webkit-scrollbar-thumb:hover {
    display: none;
  }
}

/* Scrollbar personalizada apenas para desktop */
@media (min-width: 769px) {
  .synchronized-scroll-container::-webkit-scrollbar {
    width: 8px;
  }

  .synchronized-scroll-container::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }

  .synchronized-scroll-container::-webkit-scrollbar-thumb {
    background: var(--clinic-btn-bg, #3b82f6);
    border-radius: 4px;
    transition: all 0.3s ease;
  }

  .synchronized-scroll-container::-webkit-scrollbar-thumb:hover {
    background: var(--clinic-btn-bg-hover, #2563eb);
    transform: scaleY(1.1);
  }
}

/* Responsividade para mobile - usar scroll natural da página */
@media (max-width: 768px) {
  .synchronized-scroll-container {
    height: auto !important; /* Mudança: de 100vh para auto */
    overflow: visible !important; /* Mudança: removendo overflow próprio */
    scroll-behavior: smooth !important;
    -webkit-overflow-scrolling: touch !important;
  }
  
  .filter-section {
    position: relative !important;
    z-index: 20 !important;
    backdrop-filter: blur(20px) !important;
    -webkit-backdrop-filter: blur(20px) !important;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1) !important;
  }
  
  .content-section {
    padding-bottom: 2rem;
    overflow: visible !important; /* Adicionado */
    height: auto !important; /* Adicionado */
  }
  
  .mobile-list-container {
    gap: 1.5rem;
    overflow: visible !important; /* Adicionado */
    height: auto !important; /* Adicionado */
  }
  
  .mobile-card {
    margin: 0 1rem;
    min-height: 320px !important;
    overflow: visible !important; /* Adicionado */
    height: auto !important; /* Adicionado */
  }
}

/* Garantir que não há conflitos - usar scroll natural */
.kpis-container {
  height: auto; /* Mudança: de 100vh para auto */
  overflow: visible; /* Mudança: de hidden para visible */
  position: relative;
}
</style>